export const PUBLICATIONS_CATEGORIES = '/PublicationCategory';
export const PUBLICATIONS = '/PublicationsListByCategoryGuid';
export const CONTACTS_CATEGORIES = '/ContactCategories';
export const CONTACTS = '/ContactsByCategoryGuid';
export const SHARE_DOCUMENT = '/ShareDocument';
